let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("diwMv")).then(() => parcelRequire('fSNMI'));